export default "__VITE_ASSET__952634d1__"